import axios from 'axios'
var root = 'https://api.curiouser-family.com/api/'
// var root = 'https://dk.waibaoke.cn/api/'

// var root = 'http://192.168.0.136:9997/yc-pc'

function apiAxios (method, url, params, success, failure) {
    var token = localStorage.getItem('token') ? localStorage.getItem('token'): ''
    axios({
        method: method,
        url: url,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
        headers:{
			'token':token,
			'Accept-Language':'en'
		},
        baseURL: root,
        withCredentials: false
    })
    .then(function (res) {
      if (success) {
          success(res.data)
      }
    })
    .catch(function (err) {
		if (failure) {
		    failure(err.response.data)
		}else{
			let res = err.response;
			console.log(2)
			if (res.status == 401) {
			   console.log('api error, HTTP CODE: ' + res.status)
			}
		}
       
    })
}

export default {
    get: function (url, params, success, failure) {
        return apiAxios('GET', url, params, success, failure)
    },
    post: function (url, params, success, failure) {
        return apiAxios('POST', url, params, success, failure)
    },
    put: function (url, params, success, failure) {
        return apiAxios('PUT', url, params, success, failure)
    },
    delete: function (url, params, success, failure) {
        return apiAxios('DELETE', url, params, success, failure)
    },
	imgBaseUrl:'https://api.curiouser-family.com'
}
